//import axios from '../../axios'

import axios from '../../axios'

const state = {
  statusReports: []
}

const getters = {
  allStatusReports(state) {
    return state.statusReports.sort((a, b) => b.id - a.id)
  }
}

const actions = {
  async fetchStatusReports({ commit }) {
    const response = await axios.get(`status-reports/?project_id=${localStorage.getItem('projectId')}`)

    commit('setStatusReports', response.data)
  }
}

const mutations = {
  setStatusReports: (state, statusReports) => (state.statusReports = statusReports)
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
